import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Popover as Popover$1, PopoverButton, PopoverPanel } from '@headlessui/react';
import { clsx } from 'clsx';
import { useRef, useCallback, useImperativeHandle } from 'react';
import styles from './Popover.module.css.js';

function Popover({ attachTo, inset = true, actionsRef, children, }) {
    const closeRef = useRef();
    const closePopover = useCallback(() => {
        var _a;
        (_a = closeRef.current) === null || _a === void 0 ? void 0 : _a.call(closeRef);
    }, []);
    useImperativeHandle(actionsRef, () => ({
        close: closePopover,
    }), [closePopover]);
    return (jsxs(Popover$1, { children: [jsx(PopoverButton, { as: "span", children: jsx(Fragment, { children: attachTo }) }), jsx(PopoverPanel, { anchor: "bottom", className: clsx(styles.Popover, { [styles.inset]: inset }), children: ({ close }) => {
                    closeRef.current = close;
                    return jsx(Fragment, { children: children });
                } })] }));
}

export { Popover };
//# sourceMappingURL=Popover.js.map
